import React, { useState } from 'react';
import { TableInput } from '../../../../../../../components/common';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';

interface IProps {
  moduleData: any;
  isView: any;
}

const TFoot = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);

  return (
    <tfoot>
      {/* <tr style={{ height: '50px' }}>
        <th align="left" colSpan={5} style={{ fontSize: '20px' }}>
          0 - No System, <br></br>
          1-Improvement Required, <br></br>
          2-Fully Implemented System. <br></br>
          NC Closure report to be attached for score 0. (Within 7 Days)<br></br>
          For Score 1, Improvement sheet to be attached (Within 10 days)
        </th>
      </tr> */}
      <tr>
        {/* <th align="left" colSpan={2}>
          TARGET SCORE = 80 % (30 marks)
        </th> */}
        <th align="left" colSpan={5}>
        Remarks for any Improvement/Suggestion :
          <TableInput
            isView={isView}
            name="remarks"
            type="text"
            value={moduleData.remarks}
            onChange={(e: any) => {
              handleChangeModuleData(e, moduleData);
              setRender((prev: any) => !prev);
            }}
          />
        </th>
        {/* <th></th>
        <th></th> */}
      </tr>
      <tr style={{ height: '50px' }}>
        <th align="left" colSpan={3} style={{ fontSize: '20px' }}>
        Sign of Auditor :
          <TableInput
            isView={isView}
            name="s1"
            type="text"
            value={moduleData.s1}
            onChange={(e: any) => {
              handleChangeModuleData(e, moduleData);
              setRender((prev: any) => !prev);
            }}
          />
        </th>
        <th align="left" colSpan={2} style={{ fontSize: '20px' }}>
        Sign Of Audittee :
          <TableInput
            isView={isView}
            name="s2"
            type="text"
            value={moduleData.s2}
            onChange={(e: any) => {
              handleChangeModuleData(e, moduleData);
              setRender((prev: any) => !prev);
            }}
          />
        </th>
        {/* <th align="left" style={{ fontSize: '20px' }}>
          Approved By :
          <TableInput
            isView={isView}
            name="approved_by"
            type="text"
            value={moduleData.approved_by}
            onChange={(e: any) => {
              handleChangeModuleData(e, moduleData);
              setRender((prev: any) => !prev);
            }}
          />
        </th> */}
      </tr>
      <tr >
        <th align="left" >
        Rev No:
         
        </th>
        <th align="left"  >
        Rev Date:
          
        </th>
        <th align="left" >
        Revision Detail's
          
        </th>
        <th align="left" >
        Prepared By:
          
        </th>
        <th align="left" >
        Approved By:
          
        </th>
        
      </tr>
      <tr >
        <th align="left" >
        01
         
        </th>
        <th align="left"  >
        02.04.2019
          
        </th>
        <th align="left" >
        Document no. change
          
        </th>
        <th align="left"  >
        <TableInput
            isView={isView}
            name="prepared_by"
            type="text"
            value={moduleData.prepared_by}
            onChange={(e: any) => {
              handleChangeModuleData(e, moduleData);
              setRender((prev: any) => !prev);
            }}
          />
          
        </th>
        <th align="left" >
          <TableInput
            isView={isView}
            name="approved_by"
            type="text"
            value={moduleData.approved_by}
            onChange={(e: any) => {
              handleChangeModuleData(e, moduleData);
              setRender((prev: any) => !prev);
            }}
          />
          
        </th>
        
      </tr>
    </tfoot>
  );
};

export default TFoot;
